import { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";

//ANT DESIGN IMPORTS
import { Card, Col, Collapse, Divider, Form, Input, Layout, Row, Spin, Typography } from "antd";
import { useNavigate } from "react-router-dom";

//PROJECT IMPORTS
import "../../../../assets/styles/DatePicker.css";
import CustomButton from "../../../../components/custom/CustomButton";
import MainLayout from "../../../../components/layouts/MainLayout";
import TopContent from "../../../../components/layouts/TopContent";
import cnt from "../../../../services/definedConstant";
import { BOM } from "../../../../services/definedMethod";
import TaxComponentForm from "./TaxComponentForm";
import { taxGroupApi, taxGroupLabel, taxGroupStatic } from "./taxGroup.config";
import { showCheckerApprovalModal } from "../../../../components/CheckerModal";

const { Title } = Typography;

const NewTaxGroup = (props) => {
  //DECLARED VARIABLES
  const { userData } = props;
  const { session } = userData;

  const navigate = useNavigate();
  const { newTaxGroupItems, transactionTypeData } = taxGroupStatic;
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [taxComponentData, setTaxComponentData] = useState([]);
  const [taxGroupDetail, setTaxGroupDetail] = useState("-");

  useEffect(() => {
    getTemplate();
  }, []);

  function getTemplate() {
    const url = `${taxGroupApi.taxGroup}/template`;
    let body = {
      session,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
        setIsLoading(false);
      } else {
        const objList = res;
        let tempTaxComponentData = [];

        objList?.taxComponents?.forEach((element) => {
          tempTaxComponentData.push({
            value: element.id,
            label: element.name,
          });
        });

        setTaxComponentData(tempTaxComponentData);

        setIsLoading(false);
      }
    });
  }

  function onCancel() {
    navigate("/prd1301", { replace: false });
  }

  const onSubmit = (formValues) => {
    let taxComponentsPayload = [];

    formValues.taxComponents.forEach((element) => {
      taxComponentsPayload.push({
        taxComponentId: element.taxComponentId,
        startDate: BOM.DateTime(element.startDate, "only-date"),
      });
    });
    formValues.taxComponents = taxComponentsPayload;

    const body = {
      ...formValues,
      dateFormat: "dd MMMM yyyy",
      locale: "en",
      method: "POST",
      session,
    };

    setIsLoading(true);
    BOM.FetchReqAction(
      body,
      taxGroupApi.taxGroup,
      (err, res) => {
        if (err) {
          // BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
          BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
          setIsLoading(false);
        } else {
          BOM.AlertMsg(cnt.SUCCESS, taxGroupLabel.newTaxGroupMsg);
          navigate("/prd1301", { state: { id: res.resourceId } });
          //STOP LOAD
          setIsLoading(false);
        }
      },
      {
        navigate,
        showCheckerModal: showCheckerApprovalModal,
        onCheckerApproval: (res) => {
          navigate("/prd1301", { state: { id: res.resourceId } });
          setIsLoading(false);
        },
      }
    );
  };

  return (
    <MainLayout isEnableRightSidebar={false} onSave={onSubmit}>
      <TopContent pageTitle={taxGroupLabel.newTaxGroup} pageItems={newTaxGroupItems} />
      <Spin spinning={isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
        >
          <Form
            // initialValues={{ taxComponents: [{}]}}
            form={form}
            layout="vertical"
            onFinish={onSubmit}
          >
            <Row>
              <Title level={4} style={{ margin: 0, marginBottom: 0 }}>
                {taxGroupLabel.taxGroupSetup}
              </Title>
            </Row>
            <Divider style={{ marginTop: 10, marginBottom: 30 }} />
            <Row>
              <Col span={8} style={{ padding: "0px 0px" }}>
                <Form.Item
                  label={taxGroupLabel.name}
                  name="name"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(taxGroupLabel.name),
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Divider orientation="left" orientationMargin="0">
                  {taxGroupLabel.taxComponents}
                </Divider>
                <Title
                  level={5}
                  style={{ paddingTop: 10, paddingBottom: 10, marginTop: 10 }}
                ></Title>
                <div style={{ marginBottom: "25px" }}>
                  <TaxComponentForm
                    formName={taxGroupLabel.taxComponentName}
                    taxComponentOption={taxComponentData}
                    taxGroupDetail={taxGroupDetail}
                  />
                </div>
              </Col>
            </Row>

            <Row>
              <Divider />
              {BOM.HasPermission("CREATE_TAXGROUP") && (
                <CustomButton
                  content="Submit"
                  style={{
                    width: "10%",
                    marginLeft: "auto",
                    boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                  }}
                  htmlType="submit"
                  backgroundColor="#92428B"
                  colorText="white"
                  hoverBackground="#AD4EA7"
                />
              )}
              <CustomButton
                content="Cancel"
                style={{
                  width: "10%",
                  marginLeft: "1%",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                backgroundColor="#fff"
                colorText="black"
                hoverBackground="#F5F5F5"
                onClick={onCancel}
              />
            </Row>
          </Form>
        </Card>
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

export default connect(mapStateToProps, null)(NewTaxGroup);
